<template>
  <a-dialog v-model="show" scrollable max-width="600px" persistent>
    <v-card id="widget-card" class="widget-card">
      <v-toolbar dense color="primaryLight1">
        <v-icon left>mdi-application-cog</v-icon>
        <span>
          {{
            widget && widget.id
              ? $t("widget.updateWidget")
              : $t("widget.addWidget")
          }}</span
        >
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-form
          ref="refCreateWidget"
          v-model="valid"
          lazy-validation
          enctype="multipart/form-data"
        >
          <v-radio-group
            v-model="widgetForm.isDynamicContent"
            row
            @change="onChangeWidgetType"
          >
            <a-radio
              :label="$t('widget.preConfigured')"
              :value="1"
              color="neutralGray"
              :disabled="widget && widget.id ? true : false"
            ></a-radio>
            <a-radio
              :label="$t('widget.dynamicWidget')"
              :value="2"
              color="neutralGray"
            ></a-radio>
          </v-radio-group>
          <template v-if="widgetForm.isDynamicContent == 1">
            <v-select
              class="selectField"
              v-model="widgetForm.widgetType"
              :items="widgettypelist"
              :label="`${$t('widget.widgetType')} *`"
              item-text="name"
              item-value="key"
              :menu-props="{ bottom: true, offsetY: true }"
              :no-data-text="$t('widget.notfoundPreWidget')"
              :rules="[(v) => !!v || $t('widget.widgetTypeRequired')]"
              filled
              item-color="neutralGray"
            ></v-select>
            <v-switch
              v-model="widgetForm.canShowHide"
              :label="$t('widget.canShowHide')"
            ></v-switch>
          </template>
          <template v-else>
            <a-text-field
              class="textField"
              v-model="widgetForm.title"
              :label="$t('widget.title')"
              required
              :requiredMessage="$t('ruleTitleReq')"
            ></a-text-field>
            <a-text-field
              class="textField"
              v-model="widgetForm.contentTitle"
              :label="$t('widget.contentTitle')"
            ></a-text-field>
            <a-text-field
              class="textField"
              v-model="widgetForm.contentSubtitle"
              :label="$t('widget.contentSubtitle')"
            ></a-text-field>
            <v-switch
              v-model="widgetForm.canShowHide"
              :label="$t('widget.canShowHide')"
            ></v-switch>
            <v-select
              class="selectField"
              v-model="widgetForm.widgetType"
              :items="widgettypelist"
              :label="`${$t('widget.widgetType')} *`"
              :menu-props="{ bottom: true, offsetY: true }"
              :readonly="
                widget && widget.id && widgetfiles.length > 0 ? true : false
              "
              item-text="name"
              item-value="key"
              :rules="[(v) => !!v || $t('widget.widgetTypeRequired')]"
              filled
              item-color="neutralGray"
              @blur="onBlurWidgetType"
            ></v-select>
            <!-- <v-checkbox
            v-if="widgetForm.widgetType.toLowerCase() == 'imageslider'"
            v-model="widgetForm.is_image_auto_fit"
            label="Image display in original size?"
          ></v-checkbox> -->
            <v-radio-group
              v-if="widgetForm.widgetType.toLowerCase() == 'imageslider'"
              v-model="widgetForm.is_image_auto_fit"
              row
            >
              <a-radio
                :label="$t('widget.lblOriginSize')"
                value="1"
                color="neutralGray"
              ></a-radio>
              <a-radio
                :label="$t('widget.lblFitSize')"
                value="2"
                color="neutralGray"
              ></a-radio>
            </v-radio-group>
            <!-- <v-file-input
            multiple
            v-model="widgetForm.attachment"
            :label="
              widgetForm.widgetType == ''
                ? $t('widget.fileDisableLabel')
                : $t('widget.browseFile')
            "
            outlined
            small-chips
            dense
            :accept="allow_files"
            :rules="fileRules"
            :disabled="widgetForm.widgetType == ''"
          ></v-file-input> -->
            <upload-file
              :files="widgetForm.attachment"
              :icons="fileIcons"
              dense
              outlined
              :accept="allow_files"
              :hideDetails="hideFileDetails"
              :label="
                widgetForm.widgetType == ''
                  ? $t('widget.fileDisableLabel')
                  : $t('widget.browseFile')
              "
              :placeholder="
                widgetForm.widgetType == ''
                  ? $t('widget.fileDisableLabel')
                  : $t('widget.browseFile')
              "
              v-on:add-files="addUploadingFiles"
              v-on:remove-file="removeUploadingFile"
              :disabled="widgetForm.widgetType == ''"
            ></upload-file>
            <span
              v-if="isFileRequired"
              style="color: var(--v-error-base); ma"
              >{{ this.$t("widget.fileRequired") }}</span
            >
            <div @drop.prevent="addDropFile" @dragover.prevent id="listId">
              <v-list two-line dense v-if="widgetfiles.length > 0">
                <v-list-item v-for="file in widgetfiles" :key="file.fileId">
                  <v-list-item-avatar>
                    <v-icon
                      v-text="getFileIcon(file.fileName)"
                      class="mdi-36px"
                      color="grey lighten-1"
                    ></v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ file.fileName }}</v-list-item-title>
                    <!-- <v-list-item-subtitle>{{ file.fileId }}</v-list-item-subtitle> -->
                    <v-list-item-subtitle>{{
                      file.mimetype
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon
                        color="grey lighten-1"
                        @click="deleteFile(file.fileId)"
                        >mdi-close</v-icon
                      >
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <span v-if="errorCount" class="red--text">{{
                $t("documents.invalidFileMsg", { count: errorCount })
              }}</span>
            </div>
          </template>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              color="primaryDark"
              @click="saveWidget"
              :disabled="errorCount > 0 || isDirty"
            >
              {{
                widget && widget.id ? $t("widget.update") : $t("widget.save")
              }}
            </a-btn>
          </template>
          <span>{{
            widget && widget.id ? $t("widget.update") : $t("widget.save")
          }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              color="secondary"
              @click="close()"
            >
              {{ $t("widget.close") }}
            </a-btn>
          </template>
          <span>{{ $t("widget.close") }}</span>
        </v-tooltip>
      </v-card-actions>
      <prevent-confirmation
          :prevent="isPrevent"
          @save="saveWidget"
          @discard="preventClose(true)"
          @cancel="preventClose(false)"
        >
        </prevent-confirmation>
    </v-card>
  </a-dialog>
</template>

<script>
import widgetService from "/src/api/widgetService";
import UploadFile from "/src/components/documents/UploadFile.vue";
import { createUUID, formatBytes } from "../../utils/util";
import { fileIcons, MAX_UPLOAD_SIZE } from "../../utils/constant";
import { mapGetters, mapActions } from "vuex";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import ARadio from "../../wrapper-component/ARadio.vue";
import PreventConfirmation from "../PreventConfirmation.vue";
import { cloneDeep } from "lodash";
export default {
  name: "CreateWidget",
  components: {
    UploadFile,
    ADialog,
    ABtn,
    ARadio,
    PreventConfirmation
  },
  props: {
    widget: Object,
    value: {
      type: Boolean,
      default: false,
    },
    preconfigured: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFileRequired: false,
      valid: true,
      hideFileDetails: true,
      file_accept: ["image/png", "image/jpeg", "image/bmp", "application/pdf"],
      titleRules: [
        (v) => !!v || this.$t("widget.fieldRequired"),
        (v) => (v && v.length <= 150) || this.$t("widget.fieldLess150"),
      ],
      subtitleRules: [
        (v) => (v && v.length <= 150) || this.$t("widget.fieldLess150"),
      ],
      fileRules: [
        (v) =>
          (this.widget && this.widgetfiles.length > 0) ||
          this.widgetForm.attachment.length > 0 ||
          this.$t("widget.fileRequired"),
      ],
      isPreConfigured: false,
      deletedFiles: [],
      dynamicWidgetType: "",
      widgetForm: {
        title: this.widget?.title ?? "",
        isDynamicContent: Number(this.widget?.isDynamicContent ?? 1),
        contentTitle: this.widget?.contentTitle ?? "",
        contentSubtitle: this.widget?.contentSubtitle ?? "",
        widgetType: this.widget?.widgetType ?? "",
        is_image_auto_fit: this.widget?.is_image_auto_fit ?? "1",
        canShowHide: this.widget
          ? this.widget.canShowHide == "true"
            ? true
            : false
          : false,
        sizeX: this.widget?.sizeX ?? 6,
        sizeY: this.widget?.sizeY ?? 6,
        row: this.widget?.row ? this.widget?.row : this.getLastRow,
        col: 0,
        attachment: [],
      },
      fileIcons,
      isPrevent: false,
    };
  },
  watch: {
    "widgetForm.isDynamicContent"(value) {
      this.widgetFormAsPerContent();
      this.isFileRequired = false;
    },
    "widgetForm.widgetType"(value) {
      this.contentScroll();

      if (this.widgetForm.isDynamicContent == 1) {
        const widgetType = this.widgettypelist.find(
          (wtype) => wtype.key == value
        );
        this.widgetForm.title = widgetType?.name;
        this.widgetForm.sizeX = widgetType?.sizeX;
        this.widgetForm.sizeY = widgetType?.sizeY;
        this.widgetForm.row = widgetType?.row;
        this.widgetForm.col = widgetType?.col;
      } else {
        //console.log(this.getLastRow == '-Infinity' ? this.permissionWidgetList.length : this.getLastRow, 'watch widgetForm.widgetType this.getLastRow');
        this.widgetForm.sizeX = value == "imageslider" ? 6 : 6;
        this.widgetForm.sizeY = value == "imageslider" ? 26 : 75;
        this.widgetForm.row =
          this.getLastRow == "-Infinity"
            ? this.permissionWidgetList.length
            : this.getLastRow;
        this.widgetForm.col = 0;
        if (this.widgetForm.attachment.length > 0) {
          this.widgetForm.attachment = [];
        }
      }
    },
    "widgetForm.attachment"(value) {
      if (value.length > 0) {
        this.isFileRequired = false;
      }
      this.scrollForm();
    },
    isFileRequired(value) {
      this.hideFileDetails = value;
    },
  },
  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantSettingTypes",
      getLastRow: "widget/getLastRow",
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    permissionWidgetList() {
      const data = this.tenantSettingTypes("widgettypelist");
      for (var index = 0; index < data.length; index++) {
        if (!this.getWidgetPermission(data[index].widgetType)) {
          data.splice(index, 1);
          index--;
        }
      }
      return data;
    },
    errorCount() {
      let count = 0;
      for (const item of this.widgetForm.attachment) {
        if (this.checkStatus(item).status == false) {
          count++;
        }
      }
      return count;
    },
    widgettypelist() {
      const filteredList = this.tenantSettingTypes("widgettypelist").filter(
        (data) => {
          return (
            ((this.widgetForm.isDynamicContent == 1 &&
              data.ispreconfigured == "true" &&
              this.preconfigured &&
              !this.preconfigured.includes(data.key)) ||
              (this.widgetForm.isDynamicContent == 2 &&
                data.ispreconfigured == "false")) &&
            this.getWidgetPermission(data.key)
          );
        }
      );
      return filteredList.map((item) => ({
        ...item,
        name: this.$t(`widget.${item.key}`),
      }));
    },
    widgetfiles() {
      //return this.widget.files;
      return this.widget
        ? this.widget.files.filter((data) => {
            if (
              this.deletedFiles.length > 0 &&
              this.deletedFiles.includes(data.fileId)
            ) {
            } else {
              return data;
            }
          })
        : [];
    },

    allow_files() {
      return this.file_accept.filter((data) => {
        if (this.widgetForm.widgetType.toLowerCase() == "imageslider") {
          return ["image/png", "image/jpeg", "image/bmp"].includes(data);
        } else if (this.widgetForm.widgetType.toLowerCase() == "pdfviewer") {
          return ["application/pdf"].includes(data);
        } else {
          return data;
        }
      });
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    isDirty() {
        const wFiles = cloneDeep(this.widgetfiles)
        if(this.widgetForm.attachment && this.widgetForm.attachment.length){
          for (let file of this.widgetForm.attachment) {
            wFiles.push({fileName: file.name})
          }
        }
        const widgetForm = {
          title: this.widgetForm.title,
          isDynamicContent: Number(this.widgetForm.isDynamicContent),
          contentTitle: this.widgetForm.contentTitle,
          contentSubtitle: this.widgetForm.contentSubtitle,
          widgetType: this.widgetForm.widgetType,
          is_image_auto_fit: this.widgetForm.is_image_auto_fit,
          canShowHide: String(this.widgetForm.canShowHide).toLowerCase() === "true",
          sizeX: this.widgetForm.sizeX,
          sizeY: this.widgetForm.sizeY,
          row: this.widgetForm?.row ?? this.getLastRow,
          attachment: (wFiles ?? []).map(file => file.fileName)
        };
        const widgetData = {
          title: this.widget?.title ?? "",
          isDynamicContent: Number(this.widget?.isDynamicContent ?? 1),
          contentTitle: this.widget?.contentTitle ?? "",
          contentSubtitle: this.widget?.contentSubtitle ?? "",
          widgetType: this.widget?.widgetType ?? "",
          is_image_auto_fit: this.widget?.is_image_auto_fit ?? "1",
          canShowHide: (this.widget && this.widget.canShowHide) ? String(this.widget.canShowHide).toLowerCase() === "true" : false,
          sizeX: this.widget?.sizeX ?? 6,
          sizeY: this.widget?.sizeY ?? 6,
          row: this.widget?.row ? this.widget?.row : this.getLastRow,
          attachment: (this.widget?.files ?? []).map(file => file.fileName)
        }
        return (
          JSON.stringify(widgetForm) == JSON.stringify(widgetData)
        );
    }
  },
  methods: {
    ...mapActions({
      getPanelWidgetApi: "widget/getPanelWidgets",
      addPanel: "widget/addPanel",
      updatePanel: "widget/updatePanel",
    }),
    onBlurWidgetType() {
      this.contentScroll();
    },
    contentScroll() {
      const element = document.getElementById("listId");
      if (element) {
        setTimeout(function () {
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 50);
      }
    },
    close() {
      if (!this.isDirty) {
        this.isPrevent = true
      } else {
        this.$emit("input", false);
      }
      
    },
    widgetFormAsPerContent() {
      if (this.widgetForm.isDynamicContent == 1) {
        this.isPreConfigured = 1;
      } else {
        this.isPreConfigured = null;
      }
    },
    deleteFile(fileId) {
      this.deletedFiles.push(fileId);
    },
    checkStatus(file) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      let filesWithStatus = {};
      if (!this.allow_files.includes(file.type)) {
        filesWithStatus = {
          filename: file.name,
          status: false,
          message: this.$t("fileErrorMsg", { filename: file.fileName }),
        };
      } else if (file.size > maxSize) {
        filesWithStatus = {
          filename: file.name,
          status: false,
          message: this.$t("fileSizeErrorMsg", {
            maxsize: formatBytes(maxSize),
          }),
        };
      } else {
        filesWithStatus = {
          filename: file.name,
          status: true,
          message: "Success",
        };
      }
      return filesWithStatus;
    },
    async saveWidget() {
      this.isPrevent = false;
      if (!this.widgetForm.attachment.length && !this.widgetfiles.length) {
        this.isFileRequired = true;
      }
      if (this.$refs.refCreateWidget.validate()) {
        if (
          !this.widgetForm.attachment.length &&
          !this.widgetfiles.length &&
          this.widgetForm.isDynamicContent == 2
        ) {
          this.isFileRequired = true;
          return;
        }
        var proxy = this;
        //console.log(this.widgetForm, 'this.widgetForm--');
        const data = new FormData();
        data.append(
          "widgetId",
          this.widget?.id ? this.widget.id : createUUID()
        );
        data.append("tenantId", sessionStorage.getItem("tenantId"));
        data.append("isDynamicContent", this.widgetForm.isDynamicContent);
        data.append("widgetType", this.widgetForm.widgetType);
        data.append("sizeX", this.widgetForm.sizeX);
        data.append("sizeY", this.widgetForm.sizeY);
        data.append(
          "row",
          this.widgetForm.row != "undefined"
            ? this.widgetForm.row
            : this.getLastRow ?? 0
        );

        data.append("col", this.widgetForm.col);
        data.append("is_image_auto_fit", this.widgetForm.is_image_auto_fit);
        data.append("title", this.widgetForm.title);
        data.append("contentTitle", this.widgetForm.contentTitle);
        data.append("contentSubtitle", this.widgetForm.contentSubtitle);
        data.append("canShowHide", this.widgetForm.canShowHide);
        if (this.widgetForm.isDynamicContent != 1) {
          for (let file of this.widgetForm.attachment) {
            data.append("attachment[]", file, file.name);
          }
        }

        data.append("deletedfile", JSON.stringify(this.deletedFiles));
        try {
          
          if (this.widget && this.widget.id) {
            const result = await widgetService.updateWidget(data);
            this.updatePanel(result);
            this.$eventHub.$emit("onUpdateWidget", result);
          } else {
            const result = await widgetService.createWidget(data);
            this.addPanel(result);
            this.$eventHub.$emit("onCreateWidget", result);
          }
          this.$emit(
            "alert",
            this.widget?.id
              ? this.$t("widget.updateSuccess")
              : this.$t("widget.addedSuccess"),
            "success"
          );
          this.$refs.refCreateWidget?.resetValidation();
          this.$refs.refCreateWidget?.reset();

          this.$emit("close");
        } catch (err) {
          console.log(err);
        }
      }
    },
    addUploadingFiles(files) {
      files = Array.from(files);
      this.widgetForm.attachment.push(...files);
      this.scrollForm();
    },
    removeUploadingFile(index) {
      this.widgetForm.attachment.splice(index, 1);
    },
    getFileIcon(filename) {
      let strArr = filename.split(".");
      let arrlength = strArr.length;
      if (arrlength > 0) {
        return (
          this.fileIcons[strArr[arrlength - 1].toLowerCase()] || "mdi-file"
        );
      }

      return "mdi-file";
    },
    file_path(file) {
      return `${process.env.VUE_APP_CONFIG_SERVICE}widgets/${this.widget.id}&${
        file.fileId
      }?tenant=${sessionStorage.getItem("tenantId")}`;
    },
    getWidgetPermission,
    addDropFile(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.addUploadingFiles(files);
    },
    scrollForm() {
      const element = document.getElementById("widget-card");
      setTimeout(function () {
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 500);
    },
    onChangeWidgetType() {
      this.$nextTick(() => {
        if (this.$refs.refCreateWidget) {
          if (this.widgetForm.isDynamicContent == 2) {
            if (this.widgetForm.widgetType) {
              this.dynamicWidgetType = this.widgetForm.widgetType;
            } else {
              this.widgetForm.widgetType = this.dynamicWidgetType
                ? this.dynamicWidgetType
                : "";
            }
            this.widgetForm.title = "";
            this.widgetForm.contentTitle = "";
            this.widgetForm.contentSubtitle = "";
            this.widgetForm.attachment = [];
            this.widgetForm.widgetType = "";
          } else {
            this.dynamicWidgetType = this.widgetForm.widgetType;
            this.widgetForm.widgetType = "";
          }
          this.$refs.refCreateWidget.resetValidation();
        }
      });
    },
    preventClose(status) {
      this.isPrevent = false;
      if (status) {
        this.$emit("input", false);
      }
    }
  },
};

function getWidgetPermission(type) {
  switch (type) {
    // case "upcomingmeetinglist":
    //   return this.$security.checkUserAccess("ViewMeeting");
    // case "time":
    //   return this.$security.checkUserAccess("ViewMeeting");
    case "upcomingsurveys":
      return this.$security.checkUserAccess("ViewSurveyPolls");
    default:
      return true;
  }
}
</script>

<style scoped>
::v-deep .inputfile + label {
  border: dashed 1px lightgray;
  border-radius: 3;
  color: darkgray;
  display: inline-block;
  min-width: 250px;
}

::v-deep .inputfile:focus + label,
.inputfile + label:hover {
  background-color: var(--v-warning-lighten4);
  cursor: pointer; /* "hand" cursor */
}

.selectField /deep/ .v-select__selection {
  line-height: 22px !important;
}
.selectField /deep/ .v-label {
  line-height: 18px !important;
}
</style>